export const SuccessTitle = 'OS %{newVersion} Product Release'
export const SuccessMessage1 = 'OpenSolar just got even better with our latest release.'
export const SuccessMessage2 = 'Check out the release notes and take advantage of new and improved functionality.'

export const LiteSuccessTitle = 'OS Lite %{newVersion} Product Release'
export const LiteMessage1 = 'OpenSolar Lite just got better with the latest release.'
export const LiteMessage2 = 'Check out the release notes and take advantage of new and improved functionality.'

export const WarningTitle = 'OS %{newVersion} Product Update Scheduled'
export const WarningMessage1 =
  'OpenSolar is getting even better with our latest release. Please save your changes before the update starts.'
export const WarningCountdownMessage = 'Expected %{timeRemaining} remaining before update starts.'

export const ProgressTitle = 'OS %{newVersion} Product Update in Progress'
export const ProgressMessage1 = 'OpenSolar is getting even better with our latest release.'
export const ProgressCompleteMessage = 'Update complete, please reload the page.'
export const ProgressCountdownMessage = 'Expected %{timeRemaining} remaining until update complete.'
export const ProgressOvertimeMessage = 'Update is taking longer than expected, sorry for the inconvenience.'
export const ProgressMessage2 = 'Check out the release notes while you wait.'
export const ProgressMessage3 = 'Please wait until the update is complete.'

export const ProgressCustomerTitle = 'Update in Progress'

export const ReleasePromoSuccessImageUrl = 'https://content.opensolar.com/images/update-success.png'

export const ViewReleaseNotesLabel = 'View Release Notes'
export const ReloadLabel = 'Reload'
